export default __webpack_public_path__ + "static/media/honeywood_banner_desktop.3fb31086.png";